// extracted by mini-css-extract-plugin
module.exports = {"card":"Browser_card__i7RMm"};